import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56739a1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-sites-clocking-ins-section" }
const _hoisted_2 = { class: "body bg-white" }
const _hoisted_3 = { class: "title-section-spacing" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Ultime timbrature", -1))
const _hoisted_5 = { class: "working-sites-clocking-ins w-full" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"titles-working-site-clocking-ins grid grid-cols-6 text-left\" data-v-56739a1e><p class=\"col-span-2\" data-v-56739a1e>Nome</p><p class=\"shift\" data-v-56739a1e>Tipo Timbratura</p><p class=\"shift\" data-v-56739a1e>Data timbratura</p><p class=\"shift\" data-v-56739a1e>Ora timbratura</p><p class=\"shift\" data-v-56739a1e></p></div>", 1)
const _hoisted_7 = { class: "clocking-ins-list list overflow-y-hidden overflow-x-hidden" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold justify-between items-center pt-2 pr-8 cursor-pointer select-none text-right text-primary-600" }, "Vedi tutte le timbrature", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClockingInCard = _resolveComponent("ClockingInCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddEditClockingInDialog = _resolveComponent("AddEditClockingInDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "add-clockingin text-primary block float-right font-bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingClockingInDialog = true))
          }, "Aggiungi timbratura"),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clockingIns, (clockingIn) => {
              return (_openBlock(), _createBlock(_component_ClockingInCard, {
                key: clockingIn.id,
                modelValue: clockingIn,
                scope: _ctx.scope
              }, null, 8, ["modelValue", "scope"]))
            }), 128)),
            _createVNode(_component_router_link, {
              class: "block focus:outline-none focus:shadow-outline",
              type: "button",
              to: _ctx.clockingInsUrl
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ]),
    (_ctx.isShowingClockingInDialog)
      ? (_openBlock(), _createBlock(_component_AddEditClockingInDialog, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingClockingInDialog = false)),
          onCreated: _ctx.reloadClockingIns,
          id: _ctx.id,
          scope: _ctx.scope,
          user: _ctx.user,
          workingSite: _ctx.workingSite
        }, null, 8, ["onCreated", "id", "scope", "user", "workingSite"]))
      : _createCommentVNode("", true)
  ], 64))
}